var map = {
	"./custom/app/admin/admin-sidebar/admin-sidebar.component": [
		37373,
		"src_themes_custom_app_admin_admin-sidebar_admin-sidebar_component_ts"
	],
	"./dspace/app/admin/admin-sidebar/admin-sidebar.component": [
		5258,
		"src_themes_dspace_app_admin_admin-sidebar_admin-sidebar_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90401;
module.exports = webpackAsyncContext;